export * from './atoms';
export * from './organisms';
export * from './molecules';
export * from './data';

import { BuildingAtoms } from './atoms';
import { BuildingMolecules } from './molecules';
import { BuildingOrganisms } from './organisms';


export const BuildingComponents = [
    ...BuildingAtoms,
    ...BuildingMolecules,
    ...BuildingOrganisms
]